import React from 'react';
import { GlobalStyles, alpha, type Theme } from '@mui/material';

export function BetaPageStyles({ theme }: { theme: Theme }): React.ReactElement {
  return (
    <GlobalStyles
      styles={{
        '@keyframes float': {
          '0%': {
            transform: 'translateY(0) scale(1)',
          },
          '100%': {
            transform: 'translateY(-20px) scale(1.1)',
          },
        },
        '@keyframes sparkleFloat': {
          '0%': {
            transform: 'translateY(0) scale(1)',
            opacity: 0.7,
          },
          '50%': {
            opacity: 1,
          },
          '100%': {
            transform: 'translateY(-15px) scale(1.2)',
            opacity: 0.7,
          },
        },
        '@keyframes titleGlow': {
          '0%': {
            textShadow: `0 0 10px ${alpha(theme.palette.primary.main, 0.3)}`,
          },
          '100%': {
            textShadow: `0 0 25px ${alpha(theme.palette.primary.main, 0.7)}, 0 0 40px ${alpha(
              theme.palette.primary.main,
              0.4
            )}`,
          },
        },
        '@keyframes rocketWobble': {
          '0%': {
            transform: 'translateY(0) rotate(0deg)',
          },
          '50%': {
            transform: 'translateY(-10px) rotate(3deg)',
          },
          '100%': {
            transform: 'translateY(0) rotate(-2deg)',
          },
        },
      }}
    />
  );
}
